document.addEventListener('DOMContentLoaded', function () {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        console.warn("GSAP or one of its required plugins (ScrollTrigger/SplitText) is missing for the tagline section.");
        return;
    }
    const logoBar = document.querySelector('.logo-bar-section');

    ScrollTrigger.create({
        trigger: logoBar,
        pin: true,
        start: 'top top',
        end: '+=45%',
        pinSpacing: false,
        scrub: true,
    });

    ScrollTrigger.refresh();
});